export default "__VITE_ASSET__DYhjB6CB__"